import type { AccessPair } from '@/shared/lib'

/**
 * `GET /v1/catalog/products/global` — глобальный поиск, расширенный доступ к складу.
 * Ресурс менеджера: модификатора «от имени» (`onBehalf`) нет, `?client=` ручка отвергает `400`.
 */
export const CATALOG_GLOBAL_ACCESS: AccessPair = { own: 'catalog.full.view' }
